<div class="button-with-label">
  <span class="button-label">{{ label | translate }}</span>
  <button
    [style.background-color]="currentbackgroundColor | async"
    mat-icon-button
    [ngClass]="{
      'no-selection': status === 0,
      'in-progress': status === 1,
      selected: status === 2
    }"
    (click)="onClickChoice()"
    [disabled]="disabled"
  >
    <ng-container *ngIf="status === 0">
      <mat-icon
        [style.color]="currentcolor | async"
        [style.background-color]="currentbackgroundColor | async"
        >{{ icon }}</mat-icon
      >
    </ng-container>

    <ng-container *ngIf="status === 1">
      <mat-icon
        [style.color]="currentcolor | async"
        [style.background-color]="currentbackgroundColor | async"
        >hourglass_empty</mat-icon
      >
    </ng-container>

    <ng-container *ngIf="status === 2">
      <mat-icon
        [style.color]="currentcolor | async"
        [style.background-color]="currentbackgroundColor | async"
        >{{ icon }}</mat-icon
      >
    </ng-container>
  </button>

  <p *ngIf="topic !== 'multi-action'">{{ selectedLabel | async }}</p>
</div>
